<script>
	import { cubicOut } from "svelte/easing";
	import { tweened } from "svelte/motion";
	import { fade, blur, fly, slide, scale } from "svelte/transition";

	import { percent, formatFloat, px } from "../utils";
	import { animationParameters } from "../stores";

	export let filled;
	export let max;
	export let barWidth = 27;
	export let color = "#F00";
	export let month = "";
	export let compareValue = null;
	export let compareLabel = "";
	export let valueColor = color;

	const frmtF = formatFloat(0);

	$: shareFilled = (100 * filled) / max;
	const shareCompareValue = (100 * compareValue) / max;

	const tFilled = tweened(shareFilled, $animationParameters);
	$: tFilled.set(shareFilled);
</script>

<div class="container" transition:fade={$animationParameters}>
	<div class="label text"><emph>Speicher</emph><br />im {`${month}`}</div>
	<div class="value text" style:color={valueColor}>{percent(frmtF($tFilled))}</div>
	<div class="storage" style:width={px(barWidth)}>
		{#if compareValue}
			<div class="compare-container" style:bottom={percent(shareCompareValue)}>
				<div class="line" />
				<div class="label">{compareLabel}</div>
			</div>
		{/if}
		<div class="background" />
		<div class="line top" />
		<div class="line bottom" />
		<div class="gas" style:height={percent(frmtF($tFilled))} style:background={color} style:color />
	</div>
</div>

<style lang="scss">
	.container {
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: center;
		border: 1px solid #858585;
		align-items: center;
		padding: 7px 7px 12px 7px;
		border-radius: 5px;
		position: relative;

		&:before {
			content: " ";
			display: inline-block;
			height: 12px;
			width: 12px;
			transform: translateX(-50%) rotate(135deg);
			transform-origin: center center;
			border-top: 1px solid #858585;
			border-left: 1px solid #858585;
			margin: 0 -1px -1px;
			position: absolute;
			left: 0;
			background: #f2f2f2;
		}

		&:after {
			content: " ";
			display: inline-block;
			height: 12px;
			width: 12px;
			transform: translateX(50%) rotate(135deg);
			transform-origin: center center;
			border-top: 1px solid #858585;
			border-left: 1px solid #858585;
			margin: 0 -1px -1px;
			position: absolute;
			right: 0;
			background: white;
		}
	}

	.storage {
		height: 100%;
		// background: #f2f2f2;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		width: 30%;
		position: relative;
		z-index: 1;
	}

	.background {
		background: #f2f2f2;
		height: 100%;
		width: 100%;
		position: absolute;
	}

	.label {
		emph {
			font-weight: 600;
		}
	}

	.text {
		text-align: center;
		text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
		font-size: 11.5px;
		line-height: 13px;
		letter-spacing: 0.01em;
	}

	@media (min-width: 840px) {
		.text {
			font-size: 15px;
			line-height: 16px;
		}

		.value {
			line-height: 14px;
			margin-top: 3px;
		}
	}

	.value {
		font-weight: 600;
		margin-bottom: 10px;
		transition: color 1s ease-in;
	}

	.gas {
		height: 50%;
		color: white;
		text-align: center;
		z-index: 1;
	}

	.line {
		mix-blend-mode: multiply;
		width: 23px;
		transform: translateX(-4px);
		position: absolute;
		box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);

		&.top {
			border: 0.5px solid #b5b5b5;
			top: -1px;
		}

		&.bottom {
			border: 0.5px solid #1f1f1f;
			bottom: -2px;
		}
	}

	.compare-container {
		position: absolute;
		width: 100%;
		color: #2a2a2a;
		z-index: -1;

		.line {
			border: 0.5px solid #2a2a2a;
		}

		.label {
			font-weight: 400;
			font-size: 10px;
			line-height: 11px;
			letter-spacing: 0.04em;
			transform: translate(-190%, -50%);
		}
	}
</style>
